module.exports = __webpack_public_path__ + "img/metaalConservering.533b7e29.jpg";